
import { Component, Vue, Prop } from 'vue-property-decorator';

import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListPayService extends Vue {
    @Prop({default: {}})
    private listPackage: any;
    private isCheckAll = false;

    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckAll: 'eventCheckAll'
    };

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }
}
